import useAudioPlayerStore from '@/client/stores/useAudioPlayerStore';
import { cn } from '@/utils';
import { ClassValue } from 'clsx';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';

interface TrackInfoDisplayProps {
  className?: ClassValue;
}

export const TrackInfoDisplay: React.FC<TrackInfoDisplayProps> = ({ className }) => {
  const { track, player } = useAudioPlayerStore();

  const [status, setStatus] = useState<'idle' | 'loading' | 'loaded' | 'error'>('idle');

  useEffect(() => {
    player.appendOnStatusUpdateCallback(setStatus);
    return () => player.removeOnStatusUpdateCallback(setStatus);
  }, [player]);

  return (
    <div className={cn('text-black dark:text-white', className)}>
      {status === 'loading' ? (
        `loading...`
      ) : status === 'error' ? (
        <span className="text-red-500">Error loading audio. Please check the audio source URL.</span>
      ) : (
        <>
          <span>{track?.title || ''}</span>
          <span className={'hidden lg:inline'}>{track ? ' - ' : ''}</span>
          <span className={'hidden lg:inline'}>
            {track &&
              track.artists.map(({ id, name }) => {
                return (
                  <Link key={track.title + id} onClick={() => {}} href={'#'}>
                    {name}
                  </Link>
                );
              })}
          </span>
        </>
      )}
    </div>
  );
};
